import React from 'react';
import CompanyCategoriesContainer from './CompanyCategoriesContainer';
const CompanyCategoriesPage = () => React.createElement(CompanyCategoriesContainer, null);
export default CompanyCategoriesPage;
